export const MAX_BACKUP_FILE_BYTES = 32 * 1024 * 1024;

export type BackupCounts = Readonly<Record<string, number>>;

export interface BackupIssue {
  readonly code: string;
  readonly message: string;
  readonly severity: 'conflict' | 'error' | 'warning';
}

export interface CreatedJsonBackup {
  readonly canonical_json: string;
  readonly counts: BackupCounts;
  readonly file_name: string;
  readonly whole_file_sha256: string;
}

export interface VerifiedCurrentJsonBackup {
  readonly counts: BackupCounts;
  readonly issues: readonly BackupIssue[];
  readonly matches_current_data: boolean;
  readonly whole_file_sha256: string;
}

export interface JsonRestorePreview {
  readonly counts: BackupCounts;
  readonly duplicate_entity_ids: readonly string[];
  readonly issues: readonly BackupIssue[];
  readonly whole_file_sha256: string;
}

export interface BackupOperations {
  createJsonBackup(): Promise<CreatedJsonBackup>;
  verifyCurrentJsonBackup(bytes: Uint8Array): Promise<VerifiedCurrentJsonBackup>;
  previewJsonRestore(bytes: Uint8Array): Promise<JsonRestorePreview>;
  restoreJsonBackup(input: {
    readonly expected_whole_file_sha256: string;
    readonly explicit_confirmation: true;
    readonly reselected_bytes: Uint8Array;
  }): Promise<{
    readonly reopen_required: boolean;
    readonly replacement_dataset_epoch: string;
  }>;
}
